import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Crown, Rat } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CouncilGate = ({ onUnlock }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  const enter = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/council/unlock`, { password: name });
      sessionStorage.setItem("rotu_council", res.data.token);
      onUnlock();
    } catch (err) {
      setError("The council does not know that name.");
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[110] bg-[#08080C] flex items-center justify-center px-6"
      data-testid="council-gate"
    >
      <div className="grain-overlay" />
      <div className="scanlines" />
      <div className="vignette-overlay" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-md"
        style={shake ? { animation: "glitch-shift 0.4s" } : {}}
      >
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Rat size={20} className="text-[#39FF14]" />
            <Crown size={26} className="text-[#FFE600]" />
            <Rat size={20} className="text-[#39FF14] -scale-x-100" />
          </div>
          <h1 className="font-display text-2xl sm:text-3xl font-black uppercase tracking-tight text-white glitchy" data-testid="council-prompt">
            Name one of the <span className="text-[#39FF14]">High Council</span> to enter
          </h1>
          <p className="text-[11px] tracking-[0.35em] uppercase text-zinc-600 mt-4">
            LIGMA SUGMA PSI
          </p>
        </div>

        <form onSubmit={enter} className="border border-white/10 bg-[#111118]/80 backdrop-blur-xl p-8 space-y-5" data-testid="council-form">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={40}
            placeholder="Speak a name..."
            autoFocus
            data-testid="council-name-input"
            className="w-full bg-[#08080C] border border-white/15 focus:border-[#FFE600] outline-none px-4 py-4 text-center text-lg text-white placeholder:text-zinc-700 transition-colors duration-300 font-display tracking-widest uppercase"
          />
          {error && (
            <p className="text-xs text-[#FF0055] text-center" data-testid="council-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="council-enter-button"
            className="group relative w-full py-4 border border-[#39FF14] text-[#39FF14] font-display text-sm font-bold uppercase tracking-widest overflow-hidden disabled:opacity-50"
          >
            <span className="absolute inset-0 bg-[#39FF14] translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
            <span className="relative group-hover:text-[#08080C] transition-colors duration-300">
              {loading ? "Consulting the council..." : "Enter the Nest"}
            </span>
          </button>
        </form>
      </motion.div>
    </div>
  );
};
